export const news = [
  {
    id: 1,
    title: "GTA 6 dévoile un nouveau trailer explosif",
    category: "News",
    image: "/images/gta600.jpg",
    date: "01 Mars 2026",
    excerpt: "Rockstar Games dévoile enfin un nouveau trailer très attendu...",
    content: "Article complet ici..."
  },
  {
    id: 2,
    title: "PS6 : premières rumeurs officielles",
    category: "Hardware",
    image: "/images/PS6.jpg",
    date: "28 Février 2026",
    excerpt: "Sony préparerait déjà la prochaine génération...",
    content: "Article complet ici..."
  }
];